import { render, staticRenderFns } from "./BatchAddEmployeesModal.vue?vue&type=template&id=3906672d&scoped=true&"
import script from "./BatchAddEmployeesModal.vue?vue&type=script&lang=js&"
export * from "./BatchAddEmployeesModal.vue?vue&type=script&lang=js&"
import style0 from "./BatchAddEmployeesModal.vue?vue&type=style&index=0&id=3906672d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3906672d",
  null
  
)

export default component.exports